// App.tsx
import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import {
  IonApp,
  IonRouterOutlet,
  setupIonicReact,
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

import FrontInstructionsPage from './pages/FrontInstructionsPage';
import SideInstructionsPage from './pages/SideInstructionsPage';
import ResultPage from './pages/ResultPage';
import PhotoCapture from './pages/PhotoCapture';
import DashboardPage from './pt/dashboard/DashBoardPage';
import ClientSelection from './lovable/pages/ClientList';
import CreateClient from './lovable/pages/CreateClient';
import CamTest from './pages/WebcamTest';
import PoseDebugPage from './pages/PoseDebugPage';
import Toolbar from './components/Toolbar';
import MyContextProvider from './MyContext';
import { Toaster } from './lovable/components/ui/toaster';
import SuperAdminPage from './lovable/pages/SuperAdminPage';
import { ImpersonationProvider } from './context/ImpersonationContext';
import ImpersonationBanner from './components/ImpersonationBanner';
import '@ionic/react/css/core.css';
import './theme/tailwind.css';
// ScanPage is superseded by ScanV2Page; kept for reference during transition
// import ScanPage from './lovable/pages/ScanPage';
import ScanV2Page from './pages/ScanV2Page';
setupIonicReact();

/**
 * This component is rendered *inside* <IonReactRouter>
 * so that useLocation() has a RouterContext to hook into.
 */
const RoutedOutlet: React.FC = () => {
  const location = useLocation();

  return (
    // Keying the outlet forces React to unmount/remount on every path change
    <IonRouterOutlet key={location.pathname}>
      <Route exact path="/cam" component={CamTest} />
      <Route exact path="/cam/:pose" component={CamTest} />
      <Route exact path="/pose-debug" component={PoseDebugPage} />
      <Route exact path="/scan/:profileID/:sessionID" component={ScanV2Page} />

      <Route
        exact
        path="/sessions/:profileID/:sessionID/:gender/front_img"
        component={FrontInstructionsPage}
      />
      <Route
        exact
        path="/sessions/:profileID/:sessionID/:gender/right_img"
        component={SideInstructionsPage}
      />
      <Route exact path="/sessions/:profileID/:sessionID/:gender/result" component={ResultPage} />

      <Route
        exact
        path="/photo/:profileID/:sessionID/:gender/:pose"
        component={PhotoCapture}
      />
      <Route exact path="/dashboard/:id" component={DashboardPage} />
      <Route exact path="/clients" component={ClientSelection} />
      <Route exact path="/create-client" component={CreateClient} />
      <Route exact path="/superadmin" component={SuperAdminPage} />

      <Route exact path="/">
        <Redirect to="/clients" />
      </Route>
    </IonRouterOutlet>
  );
};

const App: React.FC = () => {
  return (
    <IonApp>
      <ImpersonationProvider>
        <MyContextProvider>
          <IonReactRouter>
            <ImpersonationBanner />
            <Toolbar />
            <RoutedOutlet />
          </IonReactRouter>
        </MyContextProvider>
      </ImpersonationProvider>
      <Toaster />

    </IonApp>
  );
};

export default App;
